module.exports = __webpack_public_path__ + "img/wpo.656b0b21.svg";